export const defaultValues = {
  property_value: '',
  pie_value: '',
  anual_interest: 5.5,
  credit_years: 30,
  firstname: '',
  email: '',
  phone: '',
  currency_property_value: 'UF',
  currency_pie_value: '%',
}

export const propertyCurrencies = [
  { label: 'UF', value: 'UF' },
  { label: 'CLP', value: 'CLP' },
]

export const pieCurrencies = [
  { label: '%', value: '%' },
  { label: 'CLP', value: 'CLP' },
]

export const creditYears = [5, 10, 15, 20, 25, 30]

export const inputs = [
  {
    type: 'text',
    name: 'property_value',
    label: '¿Cuánto cuesta la propiedad?',
    placeholder: '0.00',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'pie_value',
    label: 'Valor del pie',
    placeholder: '0.00',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'credit_years',
    label: 'Plazo del crédito en años',
    placeholder: 'Estos son los circulitos',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'anual_interest',
    label: 'Tasa de interés anual',
    placeholder: '',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'firstname',
    label: 'Escribe tu nombre y apellido',
    placeholder: 'Usuario',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'email',
    name: 'email',
    label: 'Escribe tu correo electrónico',
    placeholder: 'usuario@correo.com',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'number',
    name: 'phone',
    label: 'Teléfono de contacto',
    placeholder: '56 5555 555 555',
    isRequired: true,
    className: 'col-span-2',
  },
]
